import { Avatar, Box, Flex, Typography } from "../../../ppui";
import { formatIndianCurrency } from "../../../utils/common";

export const SalaryHeaders = (currentPage, rowsPerPage) => [
  {
    key: "salary_id",
    label: "SL No.",
    isShortable: false,
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "employee_name",
    label: "Employee Name",
    align: "left",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (rows) => (
      <>
        <Flex alignItems="center">
          <Avatar
            className={"avatarHover"}
            size="sm"
            color="secondary"
            initials={`${rows.employee_name.trim().substring(0, 1).toUpperCase()}`} // Join the initials with a dot
            sx={{ marginInlineEnd: "0.625rem" }}
          />
          <Box>
            {rows.employee_name}
            <Typography
              color={"default"}
              colorVariant={"light"}
              variant={"body2"}
              mb={"0"}
            >
              #{rows.employee_code}
            </Typography>
          </Box>
        </Flex>
      </>
    ),
  },
  {
    key: "month_days",
    label: "Month Days",
    align: "left",
    isShortable: false,
    isVisible: true,
  },
  {
    key: "present_days",
    label: "Present Days",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.attendance?.present_days? row?.attendance?.present_days : '0'
  },
  
  {
    key: "payable_days",
    label: "Payable Days",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.payable_days? row?.payable_days : '0'
  },
  {
    key: "ncp_days",
    label: "NCP Days",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.ncp_days? row?.ncp_days : '0'
  },
  {
    key: "ot_hour",
    label: "OT Hour",
    align: "left",
    isShortable: false,
    isVisible: true,
    // getValue: (row) => row?.ot_hour? row?.ot_hour : '0',
    // getValue: (row) => {
    //   const minutes = row?.ot_hour ?? 0;
    //   const hrs = Math.floor(minutes / 60);
    //   const mins = minutes % 60;
    //   return `${hrs} hr ${mins} min`;
    // }
    getValue: (row) => {
      const minutes = row?.ot_hour ?? 0;
      const decimalHour = (minutes / 60).toFixed(2);
      return `${decimalHour} hr`;
    }
  },

  {
    key: "CTC_salary",
    label: "CTC",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) =>  row?.CTC_salary ? formatIndianCurrency(row?.CTC_salary.toFixed()) : "00",
  },

  {
    key: "basic_salary",
    label: "Basic Salary",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) =>  row?.payable_basic_salary ? formatIndianCurrency(row?.payable_basic_salary.toFixed()) : "00",
  },
  {
    key: "allowance",
    label: "Allowance",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      const totalAllowance = row.allowance.reduce(
        (sum, allowance) => sum + allowance.allowance_value,
        0
      );
      return totalAllowance ? formatIndianCurrency(totalAllowance.toFixed()) : "00";
    },
  },
  {
    key: "gross_salary",
    label: "Gross Salary",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.gross_salary ? formatIndianCurrency(row?.gross_salary.toFixed()) : "00"},
  },

  {
    key: "ot_amount",
    label: "OT Amount",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.ot_amount > 0 ? formatIndianCurrency(row?.ot_amount.toFixed()) : "00"},
  },

  {
    key: "bonus_amount",
    label: "Bonus",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.bonus_amount ? formatIndianCurrency(row?.bonus_amount.toFixed()) : "00"},
  },
  {
    key: "incentive_amount",
    label: "Incentive",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.incentive_amount ? formatIndianCurrency(row?.incentive_amount.toFixed()) : "00"},
  },
  {
    key: "gross_arrear",
    label: "Gross Arrear",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.gross_arrear ? formatIndianCurrency(row?.gross_arrear.toFixed()) : "00"},
  },
  {
    key: "otherearning",
    label: "Other Earnings",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.any_other_amt ? formatIndianCurrency(row?.any_other_amt.toFixed()) : "00"},
  },
  {
    key: "earning_salary",
    label: "Total Earnings",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.earning_salary ? formatIndianCurrency(row?.earning_salary.toFixed()) : "00"},
  },
  {
    key: "epf_amount",
    label: "EPF",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.epf_amount ? formatIndianCurrency(row?.epf_amount.toFixed()) : "00"}
  },
  {
    key: "esi_amount",
    label: "ESI",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.esi_amount ? formatIndianCurrency(row?.esi_amount.toFixed()) : "00"}
  },
  {
    key: "pTaxAmount",
    label: "P-TAX",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.pTaxAmount ? formatIndianCurrency(row?.pTaxAmount.toFixed()) : "00"}
  },
  {
    key: "canteen",
    label: "Canteen",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.canteen ? formatIndianCurrency(row?.canteen.toFixed()) : "00"}
  },
  {
    key: "tds",
    label: "TDS",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.tds ? formatIndianCurrency(row?.tds.toFixed()) : "00"}
  },
  {
    key: "advance_amount",
    label: "Advance Amount",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.advance_amount ? formatIndianCurrency(row?.advance_amount.toFixed()) : "00"}
  },
  {
    key: "loan_advance",
    label: "Loan Emi",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.loan_advance ? formatIndianCurrency(row?.loan_advance.toFixed()) : "00"}
  },
  {
    key: "epf_arrear",
    label: "EPF Arrear",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.epf_arrear ? formatIndianCurrency(row?.epf_arrear.toFixed()) : "00"}
  },
  {
    key: "esic_arrear",
    label: "ESI Arrear",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.esic_arrear ? formatIndianCurrency(row?.esic_arrear.toFixed()) : "00"}
  },
  {
    key: "any_other_deduction",
    label: "Other Deduction",
    align: "right",
    isShortable: false,
    isVisible: "",
    getValue: (row) => {return row?.any_other_deduction ? formatIndianCurrency(row?.any_other_deduction.toFixed()) : "00"}
  },
  {
    key: "labour_welfare",
    label: "Labour Welfare",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.labour_welfare ? formatIndianCurrency(row?.labour_welfare.toFixed()) : "00"}
  },
  {
    key: "total_deduction",
    label: "Total Deduction",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {return row?.total_deduction ? formatIndianCurrency(row?.total_deduction.toFixed()) : "00"}
    
  },

  {
    key: "payable_salary",
    label: "Net Payable Salary",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      return row?.payable_salary ? formatIndianCurrency(row?.payable_salary.toFixed()) : "00";
    }
  },
  {
    key: "remarks",
    label: "Remarks",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      const joinDate = row?.employees?.join_date ? new Date(row.employees.join_date) : null;
      const exitDate = row?.employees?.exit_formalities?.[0]?.exit_date ? new Date(row?.employees?.exit_formalities?.[0]?.exit_date) : null;
      const recordMonth = row?.month;  
      const recordYear = row?.year;   
      if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
        return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
      if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
        return `Employee exited at ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
      return row?.remarks || "--";
    }
  },
];

export const SalaryRows = [
  {
    slNo: 1,
    name: "Arjun Sharma",
    employeecode: "EMP009",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "On Time",
  },

  {
    slNo: 2,
    name: "Jane Smith",
    employeecode: "EMP005",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "Late 1 Day",
  },

  {
    slNo: 3,
    name: "Arjun Sharma",
    employeecode: "EMP003",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "On Time",
  },

  {
    slNo: 4,
    name: "Jane Smith",
    employeecode: "EMP004",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "Late 1 Day",
  },

  {
    slNo: 5,
    name: "Arjun Sharma",
    employeecode: "EMP005",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "On Time",
  },

  {
    slNo: 6,
    name: "Jane Smith",
    employeecode: "EMP006",
    uan: "123456789012",
    esino: "987654321",
    TotalPayable: "25",
    epfwages: "₹50,000",
    esicwages: "₹45,000",
    otamount: "₹2,000",
    ptaxamount: "₹1,500",
    totaldeduction: "₹3,500",
    netpayable: "₹76,500",
    remarks: "Late 1 Day",
  },
];
